export default {
  baseURL: process.env.REACT_APP_BASEURL,
  domain: process.env.REACT_APP_DOMAIN,
  environment: process.env.REACT_APP_ENV,
  ga: process.env.REACT_APP_GA,
  recaptcha: process.env.REACT_APP_RECAPTCHA
}
